(function(window, document, $) {
  'use strict';

  if (!$) {
    console.error('ADHEK V2: jQuery no disponible.');
    return;
  }


  /* ==========================================================
     ADHEK PERÚ - SHIPPING V2
     ==========================================================

     Controla:
     - UBIGEO
     - calculador de producto
     - destino
     - subtotal proyectado
     - tarifas
     - fechas
     - mensaje superior
     - popup AJAX del carrito
     - guardado de información logística en Shopify

     Reglas centrales:
     window.AdhekShippingRules

     ========================================================== */


  var UBIGEO = {
    departments: [],
    provinces: [],
    districts: [],
    loaded: false,
    loading: false,
    callbacks: []
  };


  var URLS = {

    departments:
      "//adhek-peru.com/cdn/shop/t/21/assets/1_ubigeo_departamentos.json?v=85041793527917416511788838376",

    provinces:
      "//adhek-peru.com/cdn/shop/t/21/assets/2_ubigeo_provincias.json?v=75649818195605618421788838376",

    districts:
      "//adhek-peru.com/cdn/shop/t/21/assets/3_ubigeo_distritos.json?v=24068381656684145941788838376"

  };


  var STATE = {

    destination: null,

    projectedSubtotal: 0,

    rendering: false,

    /*
      Evita guardar información idéntica
      varias veces.
    */
    lastShippingSignature: '',

    /*
      Identifica que V2 está guardando
      atributos internos del carrito.
    */
    syncingCartAttributes: false

  };


  /* ==========================================================
     UTILIDADES
     ========================================================== */


  function rules() {

    return (
      window.AdhekShippingRules ||
      null
    );

  }


  function formatName(text) {

    if (!text) {
      return '';
    }

    return String(text)
      .toLowerCase()
      .replace(
        /\b\w/g,
        function(letter) {
          return letter.toUpperCase();
        }
      );

  }


  function getPeruNow() {

    try {

      return new Date(
        new Date().toLocaleString(
          'en-US',
          {
            timeZone:
              'America/Lima'
          }
        )
      );

    } catch (error) {

      return new Date();

    }

  }


  function formatInternalDate(date) {

    if (!date) {
      return '';
    }


    var day =
      String(
        date.getDate()
      ).padStart(
        2,
        '0'
      );


    var month =
      String(
        date.getMonth() + 1
      ).padStart(
        2,
        '0'
      );


    var year =
      date.getFullYear();


    return (
      day +
      '/' +
      month +
      '/' +
      year
    );

  }


  function formatInternalDateTime(date) {

    if (!date) {
      return '';
    }


    var hours =
      String(
        date.getHours()
      ).padStart(
        2,
        '0'
      );


    var minutes =
      String(
        date.getMinutes()
      ).padStart(
        2,
        '0'
      );


    return (
      formatInternalDate(date) +
      ' ' +
      hours +
      ':' +
      minutes
    );

  }


  function saveDestination(destination) {

    try {

      localStorage.setItem(
        'adhek_shipping_destination',
        JSON.stringify({

          department:
            destination.departamento ||
            '',

          province:
            destination.provincia ||
            '',

          district:
            destination.distrito ||
            ''

        })
      );

    } catch (error) {}

  }


  function getSavedDestination() {

    try {

      var value =
        localStorage.getItem(
          'adhek_shipping_destination'
        );


      return value
        ? JSON.parse(value)
        : null;

    } catch (error) {

      return null;

    }

  }


  function getCartDestination() {

    var saved =
      getSavedDestination();


    if (!saved) {
      return null;
    }


    if (
      !saved.department ||
      !saved.province ||
      !saved.district
    ) {
      return null;
    }


    return {

      departamento:
        saved.department,

      provincia:
        saved.province,

      distrito:
        saved.district

    };

  }


  /* ==========================================================
     UBIGEO
     ========================================================== */


  function loadUbigeo(callback) {

    if (UBIGEO.loaded) {

      callback();

      return;

    }


    UBIGEO.callbacks.push(
      callback
    );


    if (UBIGEO.loading) {
      return;
    }


    UBIGEO.loading = true;


    Promise.all([

      fetch(
        URLS.departments
      )
      .then(
        function(response) {

          if (!response.ok) {
            throw new Error(
              'Departamentos'
            );
          }

          return response.json();

        }
      ),


      fetch(
        URLS.provinces
      )
      .then(
        function(response) {

          if (!response.ok) {
            throw new Error(
              'Provincias'
            );
          }

          return response.json();

        }
      ),


      fetch(
        URLS.districts
      )
      .then(
        function(response) {

          if (!response.ok) {
            throw new Error(
              'Distritos'
            );
          }

          return response.json();

        }
      )

    ])
    .then(
      function(data) {

        UBIGEO.departments =
          data[0]
            .ubigeo_departamentos ||
          [];


        UBIGEO.provinces =
          data[1]
            .ubigeo_provincias ||
          [];


        UBIGEO.districts =
          data[2]
            .ubigeo_distritos ||
          [];


        UBIGEO.loaded = true;

        UBIGEO.loading = false;


        while (
          UBIGEO.callbacks.length
        ) {

          var fn =
            UBIGEO.callbacks.shift();


          try {

            fn();

          } catch (error) {

            console.error(
              'ADHEK V2 callback:',
              error
            );

          }

        }

      }
    )
    .catch(
      function(error) {

        UBIGEO.loading = false;


        console.error(
          'ADHEK V2 UBIGEO:',
          error
        );

      }
    );

  }


  function fillDepartments(
    $select
  ) {

    loadUbigeo(
      function() {

        $select.empty();


        $select.append(
          $('<option>', {

            value: '',

            text:
              'Selecciona departamento'

          })
        );


        UBIGEO.departments.forEach(
          function(item) {

            var name =
              formatName(
                item.departamento
              );


            $select.append(
              $('<option>', {

                value:
                  item.id,

                text:
                  name

              })
              .attr(
                'data-name',
                name
              )
            );

          }
        );


        $select.prop(
          'disabled',
          false
        );

      }
    );

  }


  function fillProvinces(
    departmentId,
    $province,
    $district
  ) {

    $province.empty();


    $province.append(
      '<option value="">Selecciona provincia</option>'
    );


    $district
      .prop(
        'disabled',
        true
      )
      .html(
        '<option value="">Selecciona distrito</option>'
      );


    UBIGEO.provinces
      .filter(
        function(item) {

          return (
            String(
              item.departamento_id
            ) ===
            String(
              departmentId
            )
          );

        }
      )
      .forEach(
        function(item) {

          var name =
            formatName(
              item.provincia
            );


          $province.append(
            $('<option>', {

              value:
                item.id,

              text:
                name

            })
            .attr(
              'data-name',
              name
            )
          );

        }
      );


    $province.prop(
      'disabled',
      false
    );

  }


  function fillDistricts(
    provinceId,
    $district
  ) {

    $district.empty();


    $district.append(
      '<option value="">Selecciona distrito</option>'
    );


    UBIGEO.districts
      .filter(
        function(item) {

          return (
            String(
              item.provincia_id
            ) ===
            String(
              provinceId
            )
          );

        }
      )
      .forEach(
        function(item) {

          var name =
            formatName(
              item.distrito
            );


          $district.append(
            $('<option>', {

              value:
                item.id,

              text:
                name

            })
            .attr(
              'data-name',
              name
            )
          );

        }
      );


    $district.prop(
      'disabled',
      false
    );

  }


  /* ==========================================================
     PRODUCTO
     ========================================================== */


  function getSelectedVariant() {

    var jsonElement =
      $('[id^="ProductJson-"]')[0];


    if (!jsonElement) {
      return null;
    }


    var product;


    try {

      product =
        JSON.parse(
          jsonElement.innerHTML
        );

    } catch (error) {

      return null;

    }


    var variantId =
      $('[name="id"]').val();


    var found = null;


    $.each(
      product.variants ||
      [],
      function(
        index,
        variant
      ) {

        if (
          String(
            variant.id
          ) ===
          String(
            variantId
          )
        ) {

          found =
            variant;

          return false;

        }

      }
    );


    return found;

  }


  function getQuantity() {

    var quantity =
      parseInt(
        $('[name="quantity"]').val() ||
        1,
        10
      );


    if (
      !quantity ||
      quantity < 1
    ) {

      quantity = 1;

    }


    return quantity;

  }


  function getProjectedSubtotal(
    callback
  ) {

    var variant =
      getSelectedVariant();


    if (!variant) {

      callback(0);

      return;

    }


    var productAmount =
      Number(
        variant.price ||
        0
      ) *
      getQuantity();


    $.getJSON(
      '/cart.js'
    )
    .done(
      function(cart) {

        var currentCart =
          Number(
            cart.total_price ||
            cart.items_subtotal_price ||
            0
          );


        callback(
          currentCart +
          productAmount
        );

      }
    )
    .fail(
      function() {

        callback(
          productAmount
        );

      }
    );

  }


  /* ==========================================================
     FECHAS COURIER
     ========================================================== */


  function getRegularCourierDispatchDate(
    now
  ) {

    var r =
      rules();


    if (!r) {
      return null;
    }


    now =
      now ||
      getPeruNow();


    if (
      !r.isOperationalDay(
        now
      )
    ) {

      return r.addOperationalDays(
        now,
        1
      );

    }


    var afterCutoff =
      now.getHours() >
        20 ||
      (
        now.getHours() ===
          20 &&
        now.getMinutes() >
          0
      );


    if (!afterCutoff) {

      return r.addOperationalDays(
        now,
        1
      );

    }


    return r.addOperationalDays(
      now,
      2
    );

  }


  function getNationalArrivalRange(
    dispatchDate
  ) {

    var r =
      rules();


    if (
      !r ||
      !dispatchDate
    ) {
      return null;
    }


    return {

      min:
        r.addOperationalDays(
          dispatchDate,
          2
        ),

      max:
        r.addOperationalDays(
          dispatchDate,
          3
        )

    };

  }


  /* ==========================================================
     HTML TARJETAS
     ========================================================== */


  function card(
    extraClass,
    title,
    lines
  ) {

    var html =
      '<div class="adhek-delivery-option ' +
      (
        extraClass ||
        ''
      ) +
      '" data-adhek-v2-card="true">';


    html +=
      '<strong>' +
      title +
      '</strong>';


    $.each(
      lines ||
      [],
      function(
        index,
        line
      ) {

        if (!line) {
          return;
        }


        html +=
          '<span>' +
          line +
          '</span>';

      }
    );


    html +=
      '</div>';


    return html;

  }


  /* ==========================================================
     RESULTADOS DEL CALCULADOR
     ========================================================== */


  function buildResults(
    destination,
    subtotal
  ) {

    var r =
      rules();


    if (!r) {
      return '';
    }


    var now =
      getPeruNow();


    var zone =
      r.classifyDestination(
        destination
      );


    var free =
      r.qualifiesForFreeShipping(
        destination,
        subtotal
      );


    var remaining =
      r.getRemainingForFreeShipping(
        subtotal
      );


    var html =
      '<div data-adhek-v2-render="true">';


    /* ======================================================
       LIMA LOCAL
       ====================================================== */


    if (
      zone ===
      'LIMA_LOCAL'
    ) {

      if (free) {

        var freeDate =
          r.getNextFreeDeliveryDate(
            now
          );


        html +=
          card(
            'adhek-delivery-option--free',

            '🎁 ¡ENVÍO GRATIS!',

            [

              'Tu compra califica para envío gratis.',

              'Entrega programada: <strong>' +
                r.formatDate(
                  freeDate
                ) +
                '.</strong>'

            ]
          );

      } else {

        html +=
          card(
            'adhek-delivery-option--free',

            '🎁 Envío gratis desde S/99',

            [

              'Te faltan <strong>' +
                r.money(
                  remaining
                ) +
                '</strong> para obtener envío gratis.'

            ]
          );

      }


      var regularDate =
        r.getRegularLocalDeliveryDate(
          now
        );


      html +=
        card(
          '',

          '🚚 Envío Regular — S/15.00',

          [

            'Entrega estimada: <strong>' +
              r.formatDate(
                regularDate
              ) +
              '.</strong>'

          ]
        );


      if (
        r.isExpressEligible(
          destination
        )
      ) {

        html +=
          card(
            'adhek-delivery-option--express',

            '⚡ Envío Express — S/25.00',

            [

              'Entrega rápida según horario y disponibilidad.'

            ]
          );

      }

    }


    /* ======================================================
       LIMA COURIER
       ====================================================== */

    else if (
      zone ===
      'LIMA_COURIER'
    ) {

      if (free) {

        var freeDispatch =
          r.getNextFreeDeliveryDate(
            now
          );


        var freeArrival =
          r.getCourierArrivalRange(
            freeDispatch
          );


        var freeLines = [

          'Tu compra califica para envío gratis.',

          'Próximo despacho gratuito: <strong>' +
            r.formatDate(
              freeDispatch
            ) +
            '.</strong>'

        ];


        if (freeArrival) {

          freeLines.push(

            'Llegada estimada: <strong>' +

              r.formatDate(
                freeArrival.min
              ) +

              ' al ' +

              r.formatDate(
                freeArrival.max
              ) +

              '.</strong>'

          );

        }


        html +=
          card(
            'adhek-delivery-option--free',

            '🎁 ¡ENVÍO GRATIS!',

            freeLines
          );

      } else {

        html +=
          card(
            'adhek-delivery-option--free',

            '🎁 Envío gratis desde S/99',

            [

              'Te faltan <strong>' +
                r.money(
                  remaining
                ) +
                '</strong> para obtener envío gratis.'

            ]
          );

      }


      var courierDispatch =
        getRegularCourierDispatchDate(
          now
        );


      var courierArrival =
        r.getCourierArrivalRange(
          courierDispatch
        );


      var courierLines = [

        'Despacho mediante courier u operador logístico.'

      ];


      if (
        courierDispatch
      ) {

        courierLines.push(

          'Despacho estimado: <strong>' +

            r.formatDate(
              courierDispatch
            ) +

            '.</strong>'

        );

      }


      if (
        courierArrival
      ) {

        courierLines.push(

          'Llegada estimada: <strong>' +

            r.formatDate(
              courierArrival.min
            ) +

            ' al ' +

            r.formatDate(
              courierArrival.max
            ) +

            '.</strong>'

        );

      }


      html +=
        card(
          '',

          '🚚 Envío Regular — S/15.00',

          courierLines
        );


      html +=
        '<div class="adhek-delivery-warning" data-adhek-v2-card="true">' +
          '⚡ Envío Express no disponible para este destino.' +
        '</div>';

    }


    /* ======================================================
       RESTO DEL PERÚ
       ====================================================== */

    else {

      var provinceDispatch =
        getRegularCourierDispatchDate(
          now
        );


      var provinceArrival =
        getNationalArrivalRange(
          provinceDispatch
        );


      var provinceLines = [

        'Envío mediante courier u operador logístico.'

      ];


      if (
        provinceDispatch
      ) {

        provinceLines.push(

          'Despacho estimado: <strong>' +

            r.formatDate(
              provinceDispatch
            ) +

            '.</strong>'

        );

      }


      if (
        provinceArrival
      ) {

        provinceLines.push(

          'Llegada estimada: <strong>' +

            r.formatDate(
              provinceArrival.min
            ) +

            ' al ' +

            r.formatDate(
              provinceArrival.max
            ) +

            '.</strong>'

        );

      }


      html +=
        card(
          '',

          '🚚 Envío Regular — ' +
            r.money(
              r.config
                .provinceRegularPrice
            ),

          provinceLines
        );


      html +=
        '<div class="adhek-free-not-available" data-adhek-v2-card="true">' +

          '<strong>Envío gratis no disponible para este destino</strong>' +

          '<span>' +

            'El envío gratis desde S/99 está disponible para Lima y Callao.' +

          '</span>' +

        '</div>';


      html +=
        '<div class="adhek-delivery-warning" data-adhek-v2-card="true">' +

          '⚡ Envío Express no disponible para este destino.' +

        '</div>';

    }


    html +=
      '<div class="adhek-delivery-destination" data-adhek-v2-card="true">' +

        '📍 ' +

        destination.distrito +

        ', ' +

        destination.provincia +

        ', ' +

        destination.departamento +

      '</div>';


    html +=
      '</div>';


    return html;

  }


  function renderResults(
    $results,
    destination,
    subtotal
  ) {

    STATE.rendering =
      true;


    $results.html(

      buildResults(
        destination,
        subtotal
      )

    );


    STATE.rendering =
      false;

  }


  /* ==========================================================
     RESUMEN SUPERIOR
     ========================================================== */


  function updateSummary(
    destination,
    subtotal
  ) {

    var r =
      rules();


    if (!r) {
      return;
    }


    var $box =
      $('.adhek-shipping-box');


    if (!$box.length) {
      return;
    }


    var $title =
      $box.find(
        '[id^="AdhekShippingTitle-"]'
      );


    var $message =
      $box.find(
        '[id^="AdhekShippingMessage-"]'
      );


    var $dispatch =
      $box.find(
        '[id^="AdhekFreeDispatch-"]'
      );


    var $progress =
      $box.find(
        '.adhek-progress__bar'
      );


    var threshold =
      r.config
        .freeShippingThreshold;


    var percentage =
      Math.min(
        100,
        Math.round(
          (
            subtotal /
            threshold
          ) *
          100
        )
      );


    $progress.css(
      'width',
      percentage +
      '%'
    );


    /* ------------------------------------------------------
       SIN DESTINO
       ------------------------------------------------------ */


    if (!destination) {

      $title.text(
        'Envío gratis desde S/99'
      );


      if (
        subtotal >=
        threshold
      ) {

        $message.text(

          'Tu compra alcanza el monto mínimo. Selecciona tu destino para confirmar el beneficio.'

        );

      } else {

        $message.text(

          'Te faltan ' +

          r.money(
            r.getRemainingForFreeShipping(
              subtotal
            )
          ) +

          ' para alcanzar el monto mínimo.'

        );

      }


      $dispatch.text(

        'Selecciona tu destino para ver la fecha exacta de entrega o despacho.'

      );


      return;

    }


    var zone =
      r.classifyDestination(
        destination
      );


    var qualifies =
      r.qualifiesForFreeShipping(
        destination,
        subtotal
      );


    var now =
      getPeruNow();


    /* ------------------------------------------------------
       RESTO DEL PERÚ
       ------------------------------------------------------ */


    if (
      zone ===
      'PROVINCIAS_PERU'
    ) {

      $title.text(

        'Envío Regular — ' +

        r.money(
          r.config
            .provinceRegularPrice
        )

      );


      $message.text(

        'Enviamos a todo el Perú mediante courier u operador logístico.'

      );


      $dispatch.text(

        'El envío gratis desde S/99 está disponible para Lima y Callao.'

      );


      return;

    }


    /* ------------------------------------------------------
       LIMA SIN ENVÍO GRATIS
       ------------------------------------------------------ */


    if (!qualifies) {

      $title.text(
        'Envío gratis desde S/99'
      );


      $message.text(

        'Te faltan ' +

        r.money(
          r.getRemainingForFreeShipping(
            subtotal
          )
        ) +

        ' para obtener envío gratis.'

      );


      $dispatch.text(

        zone ===
          'LIMA_LOCAL'

          ? 'También puedes elegir Regular S/15 o Express S/25.'

          : 'También puedes elegir Regular S/15 mediante courier.'

      );


      return;

    }


    /* ------------------------------------------------------
       LIMA LOCAL GRATIS
       ------------------------------------------------------ */


    if (
      zone ===
      'LIMA_LOCAL'
    ) {

      var freeDate =
        r.getNextFreeDeliveryDate(
          now
        );


      $title.text(
        'ENVÍO GRATIS'
      );


      $message.text(

        'Tu compra califica para envío gratis.'

      );


      $dispatch.html(

        'Entrega gratuita programada: <strong>' +

        r.formatDate(
          freeDate
        ) +

        '.</strong>'

      );


      return;

    }


    /* ------------------------------------------------------
       LIMA COURIER GRATIS
       ------------------------------------------------------ */


    var freeDispatch =
      r.getNextFreeDeliveryDate(
        now
      );


    var arrival =
      r.getCourierArrivalRange(
        freeDispatch
      );


    $title.text(
      'ENVÍO GRATIS'
    );


    $message.text(

      'Tu compra califica para envío gratis mediante courier.'

    );


    $dispatch.html(

      'Próximo despacho gratuito: <strong>' +

      r.formatDate(
        freeDispatch
      ) +

      '.</strong>' +

      (
        arrival

          ? ' Llegada estimada: <strong>' +

            r.formatDate(
              arrival.min
            ) +

            ' al ' +

            r.formatDate(
              arrival.max
            ) +

            '.</strong>'

          : ''
      )

    );

  }


  /* ==========================================================
     REFRESCO DEL PRODUCTO
     ========================================================== */


  function refreshCurrent() {

    if (
      !STATE.destination
    ) {
      return;
    }


    var $results =
      $(
        '[data-adhek-shipping-results]'
      )
      .first();


    if (
      !$results.length
    ) {
      return;
    }


    getProjectedSubtotal(
      function(subtotal) {

        STATE.projectedSubtotal =
          subtotal;


        renderResults(
          $results,
          STATE.destination,
          subtotal
        );


        updateSummary(
          STATE.destination,
          subtotal
        );

      }
    );

  }


  function renderWithProtection() {

    /*
      Mostrar inmediatamente utilizando
      el último subtotal conocido.
    */

    if (
      STATE.destination &&
      STATE.projectedSubtotal >
        0
    ) {

      var $results =
        $(
          '[data-adhek-shipping-results]'
        )
        .first();


      if (
        $results.length
      ) {

        renderResults(
          $results,
          STATE.destination,
          STATE.projectedSubtotal
        );


        updateSummary(
          STATE.destination,
          STATE.projectedSubtotal
        );

      }

    }


    /*
      Consultar Shopify una sola vez
      para confirmar subtotal.
    */

    getProjectedSubtotal(
      function(subtotal) {

        STATE.projectedSubtotal =
          subtotal;


        var $results =
          $(
            '[data-adhek-shipping-results]'
          )
          .first();


        if (
          !$results.length
        ) {
          return;
        }


        renderResults(
          $results,
          STATE.destination,
          subtotal
        );


        updateSummary(
          STATE.destination,
          subtotal
        );

      }
    );

  }


  /* ==========================================================
     INFORMACIÓN INTERNA PARA SHOPIFY
     ========================================================== */


  function buildInternalShippingData(
  cart,
  destination
) {

  var r =
    rules();


  if (
    !r ||
    !cart ||
    !destination
  ) {
    return null;
  }


  var subtotal =
    Number(
      cart.total_price ||
      cart.items_subtotal_price ||
      0
    );


  var zone =
    r.classifyDestination(
      destination
    );


  var qualifies =
    r.qualifiesForFreeShipping(
      destination,
      subtotal
    );


  var now =
    getPeruNow();


  var data = {

    zone:
      zone,

    benefit:
      '',

    calculatedModality:
      '',

    destination:

      destination.distrito +

      ', ' +

      destination.provincia +

      ', ' +

      destination.departamento,

    referenceTariff:
      '',

    calculatedAt:
      formatInternalDateTime(
        now
      ),

    cutoff:
      '',

    referenceDispatch:
      '',

    referenceArrival:
      '',

    operation:
      '',

    referenceAction:
      '',


    /*
      PROGRAMACIONES INDEPENDIENTES.

      Se calculan antes del checkout para que
      Shopify Flow pueda elegir luego la correcta
      según el método REAL escogido por el cliente.
    */


    freeDispatch:
      '',

    freeArrival:
      '',

    freeAction:
      '',

    freeCutoff:
      '',


    regularDispatch:
      '',

    regularArrival:
      '',

    regularAction:
      '',

    regularCutoff:
      '',


    provinceDispatch:
      '',

    provinceArrival:
      '',

    provinceAction:
      '',

    provinceCutoff:
      '',


    expressAction:
      'GESTIONAR EXPRESS / PRIORIDAD',

    expressEligible:
      false

  };


  /* ======================================================
     LIMA LOCAL
     ====================================================== */


  if (
    zone ===
    'LIMA_LOCAL'
  ) {

    /*
      ENVÍO GRATIS
    */

    var freeDate =
      r.getNextFreeDeliveryDate(
        now
      );


    data.freeDispatch =
      formatInternalDate(
        freeDate
      );


    data.freeArrival =
      formatInternalDate(
        freeDate
      );


    data.freeAction =
      'ENTREGAR ' +
      formatInternalDate(
        freeDate
      );


    data.freeCutoff =
      'Corte 4:00 p.m. del dia anterior';


    /*
      ENVÍO REGULAR LIMA
    */

    var regularDate =
      r.getRegularLocalDeliveryDate(
        now
      );


    data.regularDispatch =
      formatInternalDate(
        regularDate
      );


    data.regularArrival =
      formatInternalDate(
        regularDate
      );


    data.regularAction =
      'ENTREGAR ' +
      formatInternalDate(
        regularDate
      );


    data.regularCutoff =
      'Corte 8:00 p.m.';


    /*
      EXPRESS DISPONIBLE
    */

    data.expressEligible =
      true;


    /*
      Mantener campos de referencia anteriores
      para compatibilidad.
    */

    if (qualifies) {

      data.benefit =
        'CALIFICA ENVIO GRATIS';


      data.calculatedModality =
        'ENVIO GRATIS';


      data.referenceTariff =
        'S/0.00';


      data.cutoff =
        data.freeCutoff;


      data.referenceDispatch =
        data.freeDispatch;


      data.referenceArrival =
        data.freeArrival;


      data.operation =
        'REPARTO LIMA';


      data.referenceAction =
        data.freeAction;

    } else {

      data.benefit =
        'NO ALCANZA ENVIO GRATIS';


      data.calculatedModality =
        'REGULAR LIMA';


      data.referenceTariff =
        'S/15.00';


      data.cutoff =
        data.regularCutoff;


      data.referenceDispatch =
        data.regularDispatch;


      data.referenceArrival =
        data.regularArrival;


      data.operation =
        'REPARTO LIMA';


      data.referenceAction =
        data.regularAction;

    }


    return data;

  }


  /* ======================================================
     LIMA COURIER
     ====================================================== */


  if (
    zone ===
    'LIMA_COURIER'
  ) {

    /*
      ENVÍO GRATIS COURIER
    */

    var freeCourierDispatch =
      r.getNextFreeDeliveryDate(
        now
      );


    var freeCourierArrival =
      r.getCourierArrivalRange(
        freeCourierDispatch
      );


    data.freeDispatch =
      formatInternalDate(
        freeCourierDispatch
      );


    if (
      freeCourierArrival
    ) {

      data.freeArrival =

        formatInternalDate(
          freeCourierArrival.min
        ) +

        ' - ' +

        formatInternalDate(
          freeCourierArrival.max
        );

    }


    data.freeAction =
      'ENTREGAR A COURIER ' +
      formatInternalDate(
        freeCourierDispatch
      );


    data.freeCutoff =
      'Corte 4:00 p.m. del dia anterior';


    /*
      ENVÍO REGULAR COURIER
    */

    var courierDispatch =
      getRegularCourierDispatchDate(
        now
      );


    var courierArrival =
      r.getCourierArrivalRange(
        courierDispatch
      );


    data.regularDispatch =
      formatInternalDate(
        courierDispatch
      );


    if (
      courierArrival
    ) {

      data.regularArrival =

        formatInternalDate(
          courierArrival.min
        ) +

        ' - ' +

        formatInternalDate(
          courierArrival.max
        );

    }


    data.regularAction =
      'ENTREGAR A COURIER ' +
      formatInternalDate(
        courierDispatch
      );


    data.regularCutoff =
      'Corte regular 8:00 p.m.';


    /*
      EXPRESS NO DISPONIBLE
    */

    data.expressEligible =
      false;


    /*
      Campos anteriores para compatibilidad.
    */

    if (qualifies) {

      data.benefit =
        'CALIFICA ENVIO GRATIS';


      data.calculatedModality =
        'ENVIO GRATIS - COURIER';


      data.referenceTariff =
        'S/0.00';


      data.cutoff =
        data.freeCutoff;


      data.referenceDispatch =
        data.freeDispatch;


      data.referenceArrival =
        data.freeArrival;


      data.operation =
        'COURIER LIMA';


      data.referenceAction =
        data.freeAction;

    } else {

      data.benefit =
        'NO ALCANZA ENVIO GRATIS';


      data.calculatedModality =
        'REGULAR COURIER LIMA';


      data.referenceTariff =
        'S/15.00';


      data.cutoff =
        data.regularCutoff;


      data.referenceDispatch =
        data.regularDispatch;


      data.referenceArrival =
        data.regularArrival;


      data.operation =
        'COURIER LIMA';


      data.referenceAction =
        data.regularAction;

    }


    return data;

  }


  /* ======================================================
     RESTO DEL PERÚ
     ====================================================== */


  var provinceDispatch =
    getRegularCourierDispatchDate(
      now
    );


  var provinceArrival =
    getNationalArrivalRange(
      provinceDispatch
    );


  data.provinceDispatch =
    formatInternalDate(
      provinceDispatch
    );


  if (
    provinceArrival
  ) {

    data.provinceArrival =

      formatInternalDate(
        provinceArrival.min
      ) +

      ' - ' +

      formatInternalDate(
        provinceArrival.max
      );

  }


  data.provinceAction =
    'DESPACHAR COURIER ' +
    formatInternalDate(
      provinceDispatch
    );


  data.provinceCutoff =
    'Corte regular 8:00 p.m.';


  data.expressEligible =
    false;


  /*
    Para compatibilidad con los atributos anteriores.
  */

  data.benefit =
    'ENVIO GRATIS NO DISPONIBLE';


  data.calculatedModality =
    'REGULAR PROVINCIA';


  data.referenceTariff =
    r.money(
      r.config
        .provinceRegularPrice
    );


  data.cutoff =
    data.provinceCutoff;


  data.referenceDispatch =
    data.provinceDispatch;


  data.referenceArrival =
    data.provinceArrival;


  data.operation =
    'COURIER NACIONAL';


  data.referenceAction =
    data.provinceAction;


  return data;

}
  /* ==========================================================
     GUARDAR ATRIBUTOS EN CARRITO SHOPIFY
     ========================================================== */


function saveShippingDataToCart(
  cart,
  callback
) {

  var destination =
    getCartDestination();


  if (
    !cart ||
    !destination
  ) {

    if (callback) {
      callback();
    }

    return;

  }


  if (
    STATE.syncingCartAttributes
  ) {

    if (callback) {
      callback();
    }

    return;

  }


  var data =
    buildInternalShippingData(
      cart,
      destination
    );


  if (!data) {

    if (callback) {
      callback();
    }

    return;

  }


  /*
    Firma estable.
  */

  var signature = [

    cart.total_price,

    data.zone,

    data.benefit,

    data.calculatedModality,

    data.destination,

    data.referenceTariff,

    data.referenceDispatch,

    data.referenceArrival,

    data.referenceAction,

    data.freeDispatch,

    data.freeArrival,

    data.freeAction,

    data.regularDispatch,

    data.regularArrival,

    data.regularAction,

    data.provinceDispatch,

    data.provinceArrival,

    data.provinceAction,

    data.expressEligible

  ].join('|');


  if (
    STATE.lastShippingSignature ===
    signature
  ) {

    if (callback) {
      callback();
    }

    return;

  }


  STATE.syncingCartAttributes =
    true;


  $.ajax({

    url:
      '/cart/update.js',

    type:
      'POST',

    dataType:
      'json',

    adhekInternalSync:
      true,

    data: {

      attributes: {

        /*
          DATOS GENERALES
        */

        '__ADHEK_Zona':
          data.zone,

        '__ADHEK_Destino':
          data.destination,

        '__ADHEK_Beneficio': '',
'__ADHEK_Modalidad_calculada': '',
'__ADHEK_Tarifa_referencia': '',
'__ADHEK_Calculado_en': '',
'__ADHEK_Corte_referencia': '',
'__ADHEK_Despacho_referencia': '',
'__ADHEK_Llegada_referencia': '',
'__ADHEK_Operacion': '',
'__ADHEK_Accion_referencia': '',


        /*
          PROGRAMACIÓN ENVÍO GRATIS
        */

        '__ADHEK_Gratis_Despacho':
          data.freeDispatch,

        '__ADHEK_Gratis_Llegada':
          data.freeArrival,

        '__ADHEK_Gratis_Accion':
          data.freeAction,

        '__ADHEK_Gratis_Corte':
          data.freeCutoff,


        /*
          PROGRAMACIÓN ENVÍO REGULAR
        */

        '__ADHEK_Regular_Despacho':
          data.regularDispatch,

        '__ADHEK_Regular_Llegada':
          data.regularArrival,

        '__ADHEK_Regular_Accion':
          data.regularAction,

        '__ADHEK_Regular_Corte':
          data.regularCutoff,


        /*
          PROGRAMACIÓN PROVINCIAS
        */

        '__ADHEK_Provincia_Despacho':
          data.provinceDispatch,

        '__ADHEK_Provincia_Llegada':
          data.provinceArrival,

        '__ADHEK_Provincia_Accion':
          data.provinceAction,

        '__ADHEK_Provincia_Corte':
          data.provinceCutoff,


        /*
          EXPRESS
        */

        '__ADHEK_Express_Habilitado':
          data.expressEligible
            ? 'SI'
            : 'NO',

        '__ADHEK_Express_Accion':
          data.expressAction

      }

    }

  })
  .done(
    function() {

      STATE.lastShippingSignature =
        signature;


      console.log(
        'ADHEK: informacion logistica guardada',
        data
      );

    }
  )
  .fail(
    function(xhr) {

      console.error(
        'ADHEK: error guardando informacion logistica',
        xhr
      );

    }
  )
  .always(
    function() {

      STATE.syncingCartAttributes =
        false;


      if (callback) {
        callback();
      }

    }
  );

}


  /* ==========================================================
     CALCULADOR
     ========================================================== */


  function initCalculator() {

    $(
      '[data-adhek-shipping-calculator]'
    )
    .each(
      function() {

        var $calculator =
          $(this);


        var $department =
          $calculator.find(
            '[data-adhek-department]'
          );


        var $province =
          $calculator.find(
            '[data-adhek-province]'
          );


        var $district =
          $calculator.find(
            '[data-adhek-district]'
          );


        var $results =
          $calculator.find(
            '[data-adhek-shipping-results]'
          );


        /*
          Quitar listeners legacy.
        */

        $department.off(
          '.adhekShipping'
        );

        $province.off(
          '.adhekShipping'
        );

        $district.off(
          '.adhekShipping'
        );


        $department.off(
          '.adhekCalcV2'
        );

        $province.off(
          '.adhekCalcV2'
        );

        $district.off(
          '.adhekCalcV2'
        );


        fillDepartments(
          $department
        );


        /* --------------------------------------------------
           DEPARTAMENTO
           -------------------------------------------------- */


        $department.on(
          'change.adhekCalcV2',
          function() {

            STATE.destination =
              null;


            $results.empty();


            $province
              .prop(
                'disabled',
                true
              )
              .html(
                '<option value="">Selecciona provincia</option>'
              );


            $district
              .prop(
                'disabled',
                true
              )
              .html(
                '<option value="">Selecciona distrito</option>'
              );


            var id =
              $(this).val();


            if (!id) {
              return;
            }


            fillProvinces(
              id,
              $province,
              $district
            );

          }
        );


        /* --------------------------------------------------
           PROVINCIA
           -------------------------------------------------- */


        $province.on(
          'change.adhekCalcV2',
          function() {

            STATE.destination =
              null;


            $results.empty();


            $district
              .prop(
                'disabled',
                true
              )
              .html(
                '<option value="">Selecciona distrito</option>'
              );


            var id =
              $(this).val();


            if (!id) {
              return;
            }


            fillDistricts(
              id,
              $district
            );

          }
        );


        /* --------------------------------------------------
           DISTRITO
           -------------------------------------------------- */


        $district.on(
          'change.adhekCalcV2',
          function() {

            if (
              !$(this).val()
            ) {
              return;
            }


            STATE.destination = {

              departamento:

                $department
                  .find(
                    ':selected'
                  )
                  .attr(
                    'data-name'
                  ) ||
                '',


              provincia:

                $province
                  .find(
                    ':selected'
                  )
                  .attr(
                    'data-name'
                  ) ||
                '',


              distrito:

                $district
                  .find(
                    ':selected'
                  )
                  .attr(
                    'data-name'
                  ) ||
                ''

            };


            saveDestination(
              STATE.destination
            );


            /*
              Permitir que un nuevo destino
              genere una nueva firma.
            */

            STATE.lastShippingSignature =
              '';


            /*
              Mostrar resultado inmediatamente.
            */

            renderWithProtection();


            /*
              Si ya hay productos en carrito,
              actualizar los datos internos
              de Shopify inmediatamente.
            */

            setTimeout(
              refreshAjaxCartShipping,
              50
            );

          }
        );


        /*
          Si algún renderer viejo cambia
          resultados, V2 los recupera.
        */

        if (
          window.MutationObserver &&
          $results.length
        ) {

          var observer =
            new MutationObserver(
              function() {

                if (
                  STATE.rendering ||
                  !STATE.destination
                ) {
                  return;
                }


                var hasV2 =
                  $results.find(
                    '[data-adhek-v2-render="true"]'
                  ).length >
                  0;


                if (!hasV2) {

                  setTimeout(
                    refreshCurrent,
                    10
                  );

                }

              }
            );


          observer.observe(
            $results[0],
            {
              childList:
                true,

              subtree:
                true
            }
          );

        }

      }
    );

  }


  /* ==========================================================
     CAMBIOS DE PRODUCTO / CANTIDAD
     ========================================================== */


  function bindProductChanges() {

    $(document)

      .off(
        '.adhekProductV2'
      )

      .on(
        'change.adhekProductV2 input.adhekProductV2',

        '[name="quantity"], [name="id"]',

        function() {

          if (
            STATE.destination
          ) {

            renderWithProtection();

          }

        }
      );

  }


  /* ==========================================================
     POPUP / CARRITO AJAX
     ========================================================== */


  function renderAjaxCartShipping(
    cart,
    container
  ) {

    var r =
      rules();


    if (!r) {
      return;
    }


    var $container =
      $(container);


    if (
      !$container.length
    ) {
      return;
    }


    var subtotal =
      Number(
        cart.total_price ||
        cart.items_subtotal_price ||
        0
      );


    var threshold =
      r.config
        .freeShippingThreshold;


    var percentage =
      Math.min(
        100,
        Math.round(
          (
            subtotal /
            threshold
          ) *
          100
        )
      );


    var remaining =
      r.getRemainingForFreeShipping(
        subtotal
      );


    var destination =
      getCartDestination();


    /* ------------------------------------------------------
       BARRA
       ------------------------------------------------------ */


    $container
      .find(
        '[data-adhek-ajax-progress], [data-adhek-cart-progress]'
      )
      .css(
        'width',
        percentage +
        '%'
      );


    /* ------------------------------------------------------
       SIN DESTINO
       ------------------------------------------------------ */


    if (!destination) {

      if (
        subtotal >=
        threshold
      ) {

        $container
          .find(
            '[data-adhek-ajax-shipping-title], [data-adhek-cart-shipping-title]'
          )
          .text(
            'Tu compra alcanza el monto para envío gratis'
          );


        $container
          .find(
            '[data-adhek-ajax-shipping-message], [data-adhek-cart-shipping-message]'
          )
          .html(
            'Selecciona tu destino en la ficha del producto para confirmar el beneficio y la fecha.'
          );

      } else {

        $container
          .find(
            '[data-adhek-ajax-shipping-title], [data-adhek-cart-shipping-title]'
          )
          .text(

            'Te faltan ' +

            r.money(
              remaining
            ) +

            ' para envío gratis'

          );


        $container
          .find(
            '[data-adhek-ajax-shipping-message], [data-adhek-cart-shipping-message]'
          )
          .text(
            'Envío gratis desde S/99 para Lima y Callao.'
          );

      }


      return;

    }


    var zone =
      r.classifyDestination(
        destination
      );


    var qualifies =
      r.qualifiesForFreeShipping(
        destination,
        subtotal
      );


    var now =
      getPeruNow();


    /* ------------------------------------------------------
       LIMA LOCAL
       ------------------------------------------------------ */


    if (
      zone ===
      'LIMA_LOCAL'
    ) {

      if (qualifies) {

        var freeDate =
          r.getNextFreeDeliveryDate(
            now
          );


        $container
          .find(
            '[data-adhek-ajax-shipping-title], [data-adhek-cart-shipping-title]'
          )
          .text(
            '¡Tu pedido califica para ENVÍO GRATIS!'
          );


        $container
          .find(
            '[data-adhek-ajax-shipping-message], [data-adhek-cart-shipping-message]'
          )
          .html(

            'Destino: <strong>' +

            destination.distrito +

            ', ' +

            destination.provincia +

            '.</strong><br>' +

            'Entrega programada: <strong>' +

            r.formatDate(
              freeDate
            ) +

            '.</strong>'

          );

      } else {

        $container
          .find(
            '[data-adhek-ajax-shipping-title], [data-adhek-cart-shipping-title]'
          )
          .text(

            'Te faltan ' +

            r.money(
              remaining
            ) +

            ' para obtener ENVÍO GRATIS'

          );


        $container
          .find(
            '[data-adhek-ajax-shipping-message], [data-adhek-cart-shipping-message]'
          )
          .html(

            'Destino: <strong>' +

            destination.distrito +

            ', ' +

            destination.provincia +

            '.</strong><br>' +

            'Envío Regular: <strong>S/15.00</strong>'

          );

      }


      return;

    }


    /* ------------------------------------------------------
       LIMA COURIER
       ------------------------------------------------------ */


    if (
      zone ===
      'LIMA_COURIER'
    ) {

      if (qualifies) {

        var freeDispatch =
          r.getNextFreeDeliveryDate(
            now
          );


        var freeArrival =
          r.getCourierArrivalRange(
            freeDispatch
          );


        var courierMessage =

          'Destino: <strong>' +

          destination.distrito +

          ', ' +

          destination.provincia +

          ', ' +

          destination.departamento +

          '.</strong><br>' +

          'Próximo despacho gratuito: <strong>' +

          r.formatDate(
            freeDispatch
          ) +

          '.</strong>';


        if (
          freeArrival
        ) {

          courierMessage +=

            '<br>Llegada estimada: <strong>' +

            r.formatDate(
              freeArrival.min
            ) +

            ' al ' +

            r.formatDate(
              freeArrival.max
            ) +

            '.</strong>';

        }


        $container
          .find(
            '[data-adhek-ajax-shipping-title], [data-adhek-cart-shipping-title]'
          )
          .text(
            '¡Tu pedido califica para ENVÍO GRATIS!'
          );


        $container
          .find(
            '[data-adhek-ajax-shipping-message], [data-adhek-cart-shipping-message]'
          )
          .html(
            courierMessage
          );

      } else {

        $container
          .find(
            '[data-adhek-ajax-shipping-title], [data-adhek-cart-shipping-title]'
          )
          .text(

            'Te faltan ' +

            r.money(
              remaining
            ) +

            ' para obtener ENVÍO GRATIS'

          );


        $container
          .find(
            '[data-adhek-ajax-shipping-message], [data-adhek-cart-shipping-message]'
          )
          .html(

            'Destino: <strong>' +

            destination.distrito +

            ', ' +

            destination.provincia +

            ', ' +

            destination.departamento +

            '.</strong><br>' +

            'Envío Regular: <strong>S/15.00</strong> mediante courier.'

          );

      }


      return;

    }


    /* ------------------------------------------------------
       RESTO DEL PERÚ
       ------------------------------------------------------ */


    $container
      .find(
        '[data-adhek-ajax-shipping-title], [data-adhek-cart-shipping-title]'
      )
      .text(

        'Envío Regular — ' +

        r.money(
          r.config
            .provinceRegularPrice
        )

      );


    $container
      .find(
        '[data-adhek-ajax-shipping-message], [data-adhek-cart-shipping-message]'
      )
      .html(

        'Destino: <strong>' +

        destination.distrito +

        ', ' +

        destination.provincia +

        ', ' +

        destination.departamento +

        '.</strong><br>' +

        'Envío mediante courier u operador logístico.<br>' +

        'El envío gratis desde S/99 está disponible para Lima y Callao.'

      );

  }


  /* ==========================================================
     REFRESCAR CARRITO
     ========================================================== */


  function refreshAjaxCartShipping() {

    $.getJSON(
      '/cart.js'
    )
    .done(
      function(cart) {

        $(
          '[data-adhek-ajax-shipping], [data-adhek-cart-shipping]'
        )
        .each(
          function() {

            renderAjaxCartShipping(
              cart,
              this
            );

          }
        );


        /*
          Guardar información interna solamente
          cuando realmente existe carrito.
        */

        if (
          cart &&
          cart.item_count >
            0
        ) {

          saveShippingDataToCart(
            cart
          );

        }

      }
    );

  }


  /* ==========================================================
     OBSERVAR CREACIÓN DEL POPUP DE SUPPLY
     ========================================================== */


  function observeAjaxCartShippingV2() {

    if (
      !window.MutationObserver
    ) {
      return;
    }


    var timer =
      null;


    var observer =
      new MutationObserver(
        function(mutations) {

          var shouldRefresh =
            false;


          $.each(
            mutations,
            function(
              index,
              mutation
            ) {

              if (
                !mutation.addedNodes ||
                !mutation.addedNodes.length
              ) {
                return;
              }


              $.each(
                mutation.addedNodes,
                function(
                  nodeIndex,
                  node
                ) {

                  if (
                    shouldRefresh ||
                    !node ||
                    node.nodeType !==
                      1
                  ) {
                    return;
                  }


                  var $node =
                    $(node);


                  if (
                    $node.is(
                      '[data-adhek-ajax-shipping], [data-adhek-cart-shipping]'
                    ) ||
                    $node.find(
                      '[data-adhek-ajax-shipping], [data-adhek-cart-shipping]'
                    ).length
                  ) {

                    shouldRefresh =
                      true;

                  }

                }
              );

            }
          );


          if (
            !shouldRefresh
          ) {
            return;
          }


          clearTimeout(
            timer
          );


          timer =
            setTimeout(
              function() {

                refreshAjaxCartShipping();

              },
              80
            );

        }
      );


    observer.observe(
      document.body,
      {

        childList:
          true,

        subtree:
          true

      }
    );

  }


  /* ==========================================================
     EVENTOS AJAX DEL CARRITO
     ========================================================== */


  $(document).ajaxComplete(
    function(
      event,
      xhr,
      settings
    ) {

      if (
        !settings ||
        !settings.url
      ) {
        return;
      }


      /*
        Ignorar el /cart/update.js
        ejecutado por nuestro propio V2.
      */

      if (
        settings.adhekInternalSync
      ) {
        return;
      }


      if (

        settings.url.indexOf(
          '/cart/add'
        ) !==
          -1 ||

        settings.url.indexOf(
          '/cart/change'
        ) !==
          -1 ||

        settings.url.indexOf(
          '/cart/update'
        ) !==
          -1

      ) {

        /*
          Permite nueva firma porque
          el total del carrito pudo cambiar.
        */

        STATE.lastShippingSignature =
          '';


        setTimeout(
          refreshAjaxCartShipping,
          100
        );


        setTimeout(
          refreshAjaxCartShipping,
          450
        );

      }

    }
  );


  /* ==========================================================
     BOTONES +/- / ELIMINAR
     ========================================================== */


  $(document).on(
    'click.adhekCartV2',

    '.ajaxifyCart--qty-adjuster, .ajaxifyCart--remove',

    function() {

      STATE.lastShippingSignature =
        '';


      setTimeout(
        refreshAjaxCartShipping,
        300
      );


      setTimeout(
        refreshAjaxCartShipping,
        700
      );

    }
  );

/* ==========================================================
   ASEGURAR DATOS ADHEK ANTES DE CHECKOUT
   ========================================================== */

(function bindCheckoutProtection() {

  var checkoutInProgress = false;

  $(document)
    .off('click.adhekCheckoutProtection')
    .on(
      'click.adhekCheckoutProtection',
      '[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]',
      function(event) {

        if (checkoutInProgress) {
          return;
        }

        var destination =
          getCartDestination();

        /*
          Si no existe destino guardado,
          dejamos que Shopify continúe normalmente.
        */
        if (!destination) {

          console.warn(
            'ADHEK: checkout sin destino logístico guardado'
          );

          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();

        checkoutInProgress = true;

        $.getJSON('/cart.js')
          .done(
            function(cart) {

              /*
                Forzar nueva sincronización.
              */
              STATE.lastShippingSignature = '';

              saveShippingDataToCart(
                cart,
                function() {

                  /*
                    Importante:
                    NO enviar el formulario del carrito.
                    Ir directamente al checkout una vez
                    guardados los atributos.
                  */

                  window.location.href =
                    '/checkout';

                }
              );

            }
          )
          .fail(
            function() {

              /*
                Si falla la consulta del carrito,
                no bloquear la compra.
              */

              window.location.href =
                '/checkout';

            }
          );

      }
    );

})();
  /* ==========================================================
     INICIO
     ========================================================== */


  $(document).ready(
    function() {

      if (!rules()) {

        console.error(

          'ADHEK V2: no se cargaron AdhekShippingRules.'

        );


        return;

      }


      initCalculator();


      bindProductChanges();


      /*
        Recuperar destino guardado
        para popup / carrito.
      */

      var savedDestination =
        getCartDestination();


      if (
        savedDestination
      ) {

        STATE.destination =
          savedDestination;

      }


      /*
        Actualizar popup y guardar
        atributos del carrito si corresponde.
      */

      refreshAjaxCartShipping();


      /*
        Detectar cuando Supply construya
        el popup después de agregar.
      */

      observeAjaxCartShippingV2();


      /*
        Resumen inicial del producto.
      */

      getProjectedSubtotal(
        function(subtotal) {

          STATE.projectedSubtotal =
            subtotal;


          updateSummary(
            null,
            subtotal
          );

        }
      );


      console.log(
        'ADHEK SHIPPING V2 ACTIVO'
      );

    }
  );


})(window, document, window.jQuery);